import { atom } from 'jotai';
export const mineGamesAtom = atom([]);
